export default __webpack_public_path__ + "static/media/ImageSeven.2f937bba.jpg";